import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

import {
    PremiumChannelKind,
    PremiumChannelType,
    premiumChannelLabel,
} from '../../../shared/global-enums';

export interface PremiumChannelsFilterProps {
    premiumChannelKind: PremiumChannelKind;
    setPremiumChannelKind: (value: PremiumChannelKind) => void;
    channelType: PremiumChannelType;
    setChannelType: (value: PremiumChannelType) => void;
}

const PremiumChannelsFilter = (props: PremiumChannelsFilterProps) => {
    return (
        <Stack
            id="premium-channels-toolbar"
            direction={{ xs: 'column', md: 'row' }}
            spacing={1.5}
            useFlexGap
            sx={{
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                width: '100%',
            }}
        >
            <ToggleButtonGroup
                exclusive
                size="medium"
                value={props.premiumChannelKind}
                aria-label="Channel status filter"
                onChange={(_, nextValue: PremiumChannelKind | null) => {
                    if (nextValue) props.setPremiumChannelKind(nextValue);
                }}
                sx={{
                    flexWrap: 'wrap',
                    width: 'fit-content',
                    maxWidth: '100%',
                }}
            >
                {Object.values(PremiumChannelKind).map((item) => (
                    <ToggleButton key={item} value={item}>
                        {premiumChannelLabel[item]}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            <ToggleButtonGroup
                exclusive
                size="medium"
                value={props.channelType}
                aria-label="Channel type filter"
                onChange={(_, nextValue: PremiumChannelType | null) => {
                    if (nextValue) props.setChannelType(nextValue);
                }}
                sx={{
                    flexWrap: 'wrap',
                    width: 'fit-content',
                    maxWidth: '100%',
                }}
            >
                {Object.values(PremiumChannelType).map((item) => (
                    <ToggleButton key={item} value={item}>
                        {item}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Stack>
    );
};

export default PremiumChannelsFilter;
